import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { LOCAL_STORAGE_NAME } from 'js/constants/App';

import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import app from 'js/store/app/App.reducer';
import search from 'js/store/search/Search.reducer';
import user from 'js/store/user/User.reducer';
import cards from 'js/store/cards/Cards.reducer';
import collections from './collections/Collections.reducer';
import notification from './notification/notification.reducer';

const collectionsPersistConfig = {
  key: `${LOCAL_STORAGE_NAME}:collections`,
  storage,
  blacklist: ['curatedCollections'],
};

const urlParams = new URLSearchParams(window.location.search);
const locale = urlParams.get('locale');
const appPersistConfig = {
  key: `${LOCAL_STORAGE_NAME}:app`,
  storage,
  whitelist: locale === 'en' || locale === 'es' ? [] : ['locale'],
  migrate: (state) => {
    if (locale === 'en' || locale === 'es') {
      return Promise.resolve({ ...state, locale });
    }
    return Promise.resolve(state);
  },
};

const RootReducer = combineReducers({
  app: persistReducer(appPersistConfig, app),
  search,
  user,
  cards,
  collections: persistReducer(collectionsPersistConfig, collections),
  notification,
});

export default RootReducer;
